import { createSlice } from '@reduxjs/toolkit';

const RegionDetailsDataSlice = createSlice({
    name: 'RegionDetailsData',
    initialState: '',
    reducers: {
        setRegionDetailsData: (state, action) => {
            return action.payload;
        },
        resetRegionDetailsData: (state) => {
            return null;
        },
    },
});

export const { setRegionDetailsData, resetRegionDetailsData } = RegionDetailsDataSlice.actions;
export default RegionDetailsDataSlice.reducer;